export default __webpack_public_path__ + "static/property-img-e9b38f4d96182405184921712580b1a6.jpg";